export const GET_PAYMENT_TRANSACTIONS = "@iweb/GET_PAYMENT_TRANSACTIONS"
